export enum OptimizeVariant {
  ORIGINAL = '0',
  VARIANT_1 = '1',
  VARIANT_2 = '2',
  VARIANT_3 = '3',
  VARIANT_4 = '4'
}

export enum OptimizeVariantNum {
  VARIANT_1 = 1,
  VARIANT_2 = 2,
  VARIANT_3 = 3,
  VARIANT_4 = 4,
  VARIANT_5 = 5
}

// optimize experiment ids
export enum OptimizeExperiment {
  FLOWPAGE_DESKTOP_LAYOUT = 'wKw8F-ipQky6EvXrP6KHvg',
  POST_DOWNLOAD_V2 = '-X0_fcZlTsmj3l-XpkR_ug',
  SKIP_CREATE_FLOWCODE_STEP_2 = 'yQNGY01rRLqdTkt0llIdPA',
  SPECIAL_OFFER = 'zxuJB-CtSXSESFLzz59MzA',
  SIGNUP_MODAL_LAYOUT = 'vDrDVp0GTxOplz2kfOSFxw',
  FULL_PAGE_CREATION_ENTRY = 'wtNCmT0lTqGe0uZWOnwqbg',
  FLOWPAGE_NEW_MOBILE_UX_EXP = '6mr-a0FbRQOmx4tNbBQ1NQ',
  ABOVE_THE_FOLD_UPDATE = 'bApVxrErQhC2hZE0iT01jg',
  CREATION_SIGNUP_STEP = 'gt2MH7NnSpa2FB2fGOqKew',
  MOBILE_CREATION_FUNNEL = 'pQNz0EcQRQe5gxtOpgNi7A',
  DESKTOP_CREATION_FUNNEL = 'OCWkPyw6Q4CR28LRQQ9l5A',
  POST_DOWNLOAD_MODAL = 'o_Z7TmppRLqxDrPScf0D4w',
  SHARE_FLOWCODE_CONTEXT = 'SyYbhJigSS-YME5S-sAKGw',
  FLOWCODE_PREVIEW_ANIMATION = 'OPhn3WrVQ5qDIk1OCxIM8A',
  EMAIL_CAPTURE = 'V9k9vWIPQZGamDAtRnw7RQ',
  POST_DOWNLOAD_REDESIGN = 'LeGyILy0Q3KjKpB4O6ip7g',
  FORCED_ACCOUNT_CREATION = '3KauA3FQRe-AgYWj7_5W9Q',
  CODE_DETAILS_DEFAULT_DRAWER = 'GlvwjCJ7QterLt7b2zlkfA',
  POST_DOWNLOAD_V3 = 'WB0-bGT6QQ2P01bfMnfbxQ',
  HOMEPAGE_AUTODESIGN = 'zPU2oDslRwmXO9u2VmUt1Q',
  PRO_FUNNEL_STEPS = 'LI5Ayw9oQM6_yqYS5hWwbw',
  HOMEPAGE_UPDATED_GENERATOR = 'CZ5dBH6CTy2MtKVNBMxFpQ',
  HOMEPAGE_PRO_UPSELL = 'K23eKUdVRlSDpHMLTZrBJQ',
  MOBILE_FORCED_ACCOUNT_CREATION = 'wtnIF28OT9WizYOnVFz21A',
  PAGE_BOTTOM_NAV_MOBILE = '6mcnhu6tTWKc24DU-TPXTw',
  POST_DOWNLOAD_V5 = 'ERcUR-xoTn2MrD9uDfVk0w',
  TWO_LINKS_TO_PUBLISH = 'BBMVCZmBQCuzbVynndCFFQ',
  FLOWPAGE_POST_PUBLISH = 'qeBUCLbgQ4eos0xuwDBlhw',
  HOMEPAGE_PRO_UPSELL_TOP_NAV_BANNER = 'EQUEYG0tRuCK9jDosTvX8w',
  PRO_PLUS_PLANS_PAGE = '4K-DeE_KQvWggpCYN8_zmw'
}
